var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, runInAction, when, makeObservable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
import { bound } from '../../../utils/decorators/basic';
export class AppBoot {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        // document.addEventListener('readystatechange', this.setReadyState);
    }
    get app() {
        return this.parent;
    }
    startupTime = new Date();
    // @observable documentReadyState: 'loading' | 'interactive' | 'complete' = 'loading';
    isAppRendered = false;
    isContentRendered = false;
    isInteractive = false;
    isInteractiveStable = false;
    initInteractiveParts() {
        runtime.runtimeScheduler.addToNextIdleStateChange(() => {
            this.isInteractive = true;
            setTimeout(() => {
                runtime.runtimeScheduler.addToNextIdleStateChange(() => (this.isInteractiveStable = true));
            }, 2000);
        });
    }
    async onReachedContentRendered() {
        if (runtime.isServerRuntime)
            return;
        runInAction(() => (this.isContentRendered = true));
        this.app.director.hooker.enableAllHooks();
        await when(() => !!runtime.streamedPackages.Defer);
        this.initInteractiveParts();
        if (runtime.isBrowserRuntime && runtime.solidBrowserRuntime.browserDevice.isTabletOrSmartphone) {
            window.scrollTo(0, 1); // hide adress bar, but does not work on many browsers :-(
        }
    }
    /*
    @action.bound
    setReadyState() {
      // console.log('setReadyState', document.readyState, this.timeSinceStartup);
      this.documentReadyState = document.readyState;
    }
  */
    get timeSinceStartup() {
        return new Date().getTime() - this.startupTime.getTime();
    }
}
__decorate([
    observable
], AppBoot.prototype, "isAppRendered", void 0);
__decorate([
    observable
], AppBoot.prototype, "isContentRendered", void 0);
__decorate([
    observable
], AppBoot.prototype, "isInteractive", void 0);
__decorate([
    observable
], AppBoot.prototype, "isInteractiveStable", void 0);
__decorate([
    bound
], AppBoot.prototype, "initInteractiveParts", null);
__decorate([
    action.bound
], AppBoot.prototype, "onReachedContentRendered", null);
